export default __webpack_public_path__ + "static/media/ci-map-zoom-in.ef378272.svg";